// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
Vue.prototype.$axios = axios;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import vuequilleditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(vuequilleditor);

import VueAliplayerV2 from "vue-aliplayer-v2";
Vue.use(VueAliplayerV2);

import storage from "good-storage";
Vue.prototype.$storage = storage;

// http request拦截器 添加一个请求拦截器
axios.interceptors.request.use(
  function(config) {
    let token = storage.get("token");
    //console.log("token=============="+token);
    let userId;
    let idCard;
    let userName;
    if (storage.get("declareUser")) {
      userId = storage.get("declareUser").id;

      idCard = storage.get("declareUser").idCard;

      userName = storage.get("declareUser").userName;
    }

    if (token) {
      config.headers.token = token; //将token放到请求头发送给服务器
    }

    if (userId) {
      config.headers.userId = userId;
    }
    if (idCard) {
      config.headers.idCard = idCard;
    }
    if (userName) {
      config.headers.userName = encodeURIComponent(userName); //有中文 要进行encodeURIComponent编码
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

import { Message } from "element-ui";

Vue.prototype.$message = Message;

// 添加响应拦截器
axios.interceptors.response.use(
  function(resp) {
    if (resp.data.code != null && resp.data.code != undefined) {
      if (resp.data.code === "4003") {
        ElementUI.Message({
          showClose: true,
          message: "请求过于频繁,于一分钟后重试！",
          type: "error"
        });
        return false;
      } else if (resp.data.code === "4001" || resp.data.code === "4002") {
        console.log("登录超时报警！！！！！！===============================" + resp.data.code);
        ElementUI.MessageBox("登录超时！请重新登录").then(_ => {
            router.push("/login");
          }).catch(_ => {});
      } else if (resp.data.code === "4004") {
        //token 即将过期  更新token
        let parames = new URLSearchParams();
        parames.append("userId", storage.get("declareUser").id);
        parames.append("oldToken", storage.get("token"));
        axios
          .post(Vue.prototype.serverUrl + "/reVerification", parames)
          .then(resp1 => {
            if (resp1.data.code === 1) {
              storage.set("token", resp1.data.token);
            } else {
              ElementUI.Message({
                showClose: true,
                message: "身份验证失败！",
                type: "error"
              });
            }
          })
          .catch(err => {
            ElementUI.Message({
              showClose: true,
              message: "身份验证失败！",
              type: "error"
            });
          });
      }
    }

    return resp;
  },
  function(error) {
    return Promise.reject(error);
  }
);

//水印
Vue.prototype.$watermark = function watermark(settings) {
  debugger;
  //默认设置
  var defaultSettings = {
    watermark_txt: "text",
    watermark_x: 20, //水印起始位置x轴坐标
    watermark_y: 20, //水印起始位置Y轴坐标
    watermark_rows: 5, //水印行数
    watermark_cols: 10, //水印列数
    watermark_x_space: 100, //水印x轴间隔
    watermark_y_space: 100, //水印y轴间隔
    watermark_color: "#aaa", //水印字体颜色
    watermark_alpha: 0.4, //水印透明度
    watermark_fontsize: "15px", //水印字体大小
    watermark_font: "微软雅黑", //水印字体
    watermark_width: 210, //水印宽度
    watermark_height: 80, //水印长度
    watermark_angle: 15 //水印倾斜度数
  };
  //采用配置项替换默认值，作用类似jquery.extend
  if (arguments.length === 1 && typeof arguments[0] === "object") {
    var src = arguments[0] || {};
    for (var keyS in src) {
      if (
        src[keyS] &&
        defaultSettings[keyS] &&
        src[keyS] === defaultSettings[keyS]
      )
        continue;
      else if (src[keyS]) defaultSettings[keyS] = src[keyS];
    }
  }

  var oTemp = document.createDocumentFragment();

  //获取页面最大宽度
  var page_width = Math.max(
    document.body.scrollWidth,
    document.body.clientWidth
  );
  var cutWidth = page_width * 0.015;
  var page_width = page_width - cutWidth;
  //获取页面最大高度
  var page_height =
    Math.max(document.body.scrollHeight, document.body.clientHeight) + 650;
  // var page_height = document.body.scrollHeight+document.body.scrollTop;
  //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
  if (
    defaultSettings.watermark_cols == 0 ||
    parseInt(
      defaultSettings.watermark_x +
        defaultSettings.watermark_width * defaultSettings.watermark_cols +
        defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)
    ) > page_width
  ) {
    defaultSettings.watermark_cols = parseInt(
      (page_width -
        defaultSettings.watermark_x +
        defaultSettings.watermark_x_space) /
        (defaultSettings.watermark_width + defaultSettings.watermark_x_space) -
        1
    );
    defaultSettings.watermark_x_space = parseInt(
      (page_width -
        defaultSettings.watermark_x -
        defaultSettings.watermark_width * defaultSettings.watermark_cols) /
        (defaultSettings.watermark_cols - 1) -
        10
    );
  }
  //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
  if (
    defaultSettings.watermark_rows == 0 ||
    parseInt(
      defaultSettings.watermark_y +
        defaultSettings.watermark_height * defaultSettings.watermark_rows +
        defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)
    ) > page_height
  ) {
    defaultSettings.watermark_rows = parseInt(
      (defaultSettings.watermark_y_space +
        page_height -
        defaultSettings.watermark_y) /
        (defaultSettings.watermark_height + defaultSettings.watermark_y_space)
    );
    defaultSettings.watermark_y_space = parseInt(
      (page_height -
        defaultSettings.watermark_y -
        defaultSettings.watermark_height * defaultSettings.watermark_rows) /
        (defaultSettings.watermark_rows - 1)
    );
  }
  var x;
  var y;
  for (var i = 0; i < defaultSettings.watermark_rows; i++) {
    y =
      defaultSettings.watermark_y +
      (defaultSettings.watermark_y_space + defaultSettings.watermark_height) *
        i;
    for (var j = 0; j < defaultSettings.watermark_cols; j++) {
      x =
        defaultSettings.watermark_x +
        (defaultSettings.watermark_width + defaultSettings.watermark_x_space) *
          j;

      var mask_div = document.createElement("div");
      mask_div.id = "mask_div" + i + j;
      mask_div.className = "mask_div";
      mask_div.appendChild(
        document.createTextNode(defaultSettings.watermark_txt)
      );
      //设置水印div倾斜显示
      mask_div.style.webkitTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.MozTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.msTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.OTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.transform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.visibility = "";
      mask_div.style.position = "absolute";
      mask_div.style.left = x + "px";
      mask_div.style.top = y + "px";
      mask_div.style.overflow = "hidden";
      mask_div.style.zIndex = "9999";
      mask_div.style.pointerEvents = "none"; //pointer-events:none  让水印不遮挡页面的点击事件
      //mask_div.style.border="solid #eee 1px";
      mask_div.style.opacity = defaultSettings.watermark_alpha;
      mask_div.style.fontSize = defaultSettings.watermark_fontsize;
      mask_div.style.fontFamily = defaultSettings.watermark_font;
      mask_div.style.color = defaultSettings.watermark_color;
      mask_div.style.textAlign = "center";
      mask_div.style.width = defaultSettings.watermark_width + "px";
      mask_div.style.height = defaultSettings.watermark_height + "px";
      mask_div.style.display = "block";
      oTemp.appendChild(mask_div);
    }
  }
  document.body.appendChild(oTemp);
};

import SlideVerify from "vue-monoplasty-slide-verify";

Vue.use(SlideVerify);

//import css
//import 'vue-beauty/package/style/vue-beauty.min.css'

//import components
//import {tree} from 'vue-beauty'
//Vue.use(tree)

//192.168.1.106
//http://192.168.1.108:7777/declare
//https://api.zcjnzx.com/declare

// 导入服务器配置工具
import { getServerConfig } from './utils/serverConfig';

// 获取服务器配置
const serverConfig = getServerConfig();

Vue.prototype.serverUrl = serverConfig.serverUrl;
Vue.prototype.adminLoginUrl = serverConfig.adminLoginUrl;
Vue.prototype.TechServerUrl = serverConfig.techServerUrl;

Vue.prototype.prefiexUrl = "/static-ueditor/";

Vue.prototype.organStatus = 1; // 1工大 2协会 3建投

Vue.prototype.declareCode = "zgrl06";

//import 'lib-flexible'
//客服QQ
Vue.prototype.QQnumberOne = "761925573";

Vue.prototype.QQnumberTwo = "761925573";

Vue.prototype.QQnumberThree = "2406819804";

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js